import { RootState } from 'rootReducer';

export const selectPaymentInformationErrorResponse = (state: RootState) =>
  state.ui.apps.survey.Handlebars.paymentInformationErrorResponse;

export const selectPaymentInformationStatus = (state: RootState) =>
  state.ui.apps.survey.Handlebars.sendPaymentInformationStatus;
